// ==============================|| LOGO ||============================== //

const Logo = () => {
    return <img src={"/logo.png"} alt="Patched Orbit" width="40" />;
};

export default Logo;
